// Het zoekveld boven de keuzelijsten 'Materiaal' en 'Coachadvies': met de hele
// meetstandaard erin is doorscrollen geen doen meer.
//
// WAAROM DE GEKOZEN OPTIE ALTIJD BLIJFT STAAN. Een <select> die zijn eigen
// waarde niet in de optielijst vindt, rendert leeg. Zonder die uitzondering
// lijkt een zoekterm die niet op de gekozen naam matcht de keuze te wissen,
// terwijl het formulier hem gewoon nog draagt.
//
// AI-CONTEXT: See docs/features/materials-co2-circulariteit.md

/**
 * @typedef {import('./materialCatalog').CatalogGroup} CatalogGroup
 */

/**
 * Filter de groepen van de keuzelijst op een zoekterm.
 *
 * Matcht op de naam van een optie; matcht de categorie zelf, dan blijft de
 * hele groep staan. Groepen zonder overgebleven optie verdwijnen.
 *
 * @param {Array<CatalogGroup>} [groups] - Groepen uit buildCatalogGroups
 * @param {string} [term] - Wat de gebruiker typte
 * @param {string} [keepValue] - Optiewaarde die hoe dan ook in de lijst blijft
 * @returns {Array<CatalogGroup>}
 */
const filterCatalogGroups = (groups, term, keepValue = '') => {
    const list = Array.isArray(groups) ? groups : []
    const needle = String(term || '').trim().toLowerCase()
    if (!needle) return list

    return list.reduce((kept, group) => {
        const categoryMatches = String(group.category || '').toLowerCase().includes(needle)
            || String(group.label || '').toLowerCase().includes(needle)

        const options = (group.options || []).filter((option) => (
            categoryMatches
            || (keepValue && option.value === keepValue)
            || String(option.title || '').toLowerCase().includes(needle)
        ))

        if (options.length > 0) kept.push({ ...group, options })
        return kept
    }, [])
}

export default filterCatalogGroups
